exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table,td,th{padding:10px 5px}table{border:1px solid #d3d3d3;width:100%}tr:nth-child(2n){background:#e9e9e9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-19504ece","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/extracurriculares/external_enrollment/pay_reserve.vue
// module id = mArL
// module chunks = 2